import React from 'react';
import Alert from '@99designs/react-components/components/Alert';
import { FormattedMessage } from 'react-intl';

export default ({ design }) => {
    const { isPreviewOnly, permission: { canView }, width } = design;
    if (!isPreviewOnly || !canView || !width) {
        return null;
    }

    return (
        <div className="design-details__alert">
            <Alert canBeDismissed={true}>
                <FormattedMessage id="file_is_preview_a" />
                <a href={design.downloadUrl} className="link link--bleached-as">
                    <FormattedMessage id="file_is_preview_b" />
                </a>.
            </Alert>
        </div>
    );
};



// WEBPACK FOOTER //
// ./~/@99designs/ddo/components/PreviewAlert.jsx